<template>
	<sort-control :condition="data" :isload="isload"></sort-control>
</template>

<script>
import sortControl from "@global/components/productList_vue/sort";
export default {
	name: "SortApp",
	props: ["data", "isload"],
	components: {
		sortControl,
	},
};
</script>

<style></style>
